import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { TablePlaceholder } from 'shared/placeholders';
import { Table } from 'shared/table';
import { TableComponentParams } from 'shared/table/hoc/withPagination';
import { formatCurrency, formatDate } from 'shared/utils';

export interface TransactionTableProps extends TableComponentParams<Movimiento> { }

export const TransactionTable = ({
  tableContent,
  placeholderRows,
}: TransactionTableProps) => {
  return (
    <Table
      thead={
        <tr>
          <th>Tarjeta</th>
          <th>Cuenta</th>
          <th>Fecha</th>
          <th>Número de Autorización</th>
          <th>Establecimiento</th>
          <th>Rubro</th>
          <th>Importe</th>
          <th>Tipo de Transacción</th>
        </tr>
      }
      tbody={
        <>
          {tableContent?.map((row) => (
            <tr
              key={`movimiento${row.numeroComprobante}`}
              data-testid={`movimiento${row.numeroComprobante}`}
            >
              <td className="align-middle">{row.numeroTarjeta || '-'}</td>
              <td className="align-middle">{row.numeroCuenta || '-'}</td>
              <td className="align-middle">{row.fecha ? formatDate(row.fecha) : '-'}</td>
              <td className="align-middle">{row.numeroComprobante || '-'}</td>
              <td className="align-middle">{row.establecimiento || '-'}</td>
              <td className="align-middle">{row.rubro || '-'}</td>
              <td className="align-middle">{formatCurrency(row.importe)}</td>
              <td className="align-middle">{row.detalleTipoOperacion || '-'}</td>
            </tr>
          )) || <TablePlaceholder cols={8} rows={placeholderRows || 5} />}
        </>
      }
    />
  );
};
